export default __webpack_public_path__ + "static/media/NewBillClose.3dc126b9.svg";